import type { RouteTitleMap } from './route-title';

/**
 * The browser tab's name per route (`RouteAnnouncer`). A route missing
 * here shows its bare path in the tab, so the tab read "/support" and
 * "/site-settings" until both were added (2026-10-31). Kept out of
 * `AppShell.tsx` so the component file exports only components, and so a
 * test can read it.
 */
export const ROUTE_TITLES: RouteTitleMap = {
  '/overview': 'Overview',
  '/fleet': 'Robots',
  '/devices': 'Devices',
  '/alerts': 'Alerts',
  '/metrics': 'Metrics',
  '/tasks': 'Tasks',
  '/access': 'Access',
  '/audit': 'Audit',
  '/profile': 'Profile',
  '/activity': 'My activity',
  '/support': 'Support',
  '/site-settings': 'Site settings',
};
